import { getApi, http, adminGet, adminPost, adminPut } from './useAdminCore';
// ==================== Chat / AI ====================
function getPreLoadInstructions(onSuccess = null) {
    adminGet("/Chats/PreLoadInstructions", (result) => {
        if (onSuccess)
            onSuccess(result || []);
    });
}
function createPreLoadInstruction(data, onSuccess = null, onError = null) {
    adminPost('/Chats/PreLoadInstructions', data, onSuccess, (error) => {
        if (onError)
            onError('Failed to create pre-load instruction');
    });
}
function updatePreLoadInstruction(id, data, onSuccess = null, onError = null) {
    adminPut('/Chats/PreLoadInstructions/' + id, { id: id, ...data }, onSuccess, (error) => {
        if (onError)
            onError('Failed to update pre-load instruction');
    });
}
function deletePreLoadInstruction(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Chats/PreLoadInstructions/' + id)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting pre-load instruction:', error);
        if (onError)
            onError('Failed to delete pre-load instruction');
    });
}
function getContextAppActions(onSuccess = null) {
    adminGet("/Chats/ContextAppActions", (result) => {
        if (onSuccess)
            onSuccess(result || []);
    });
}
function createContextAppAction(data, onSuccess = null, onError = null) {
    adminPost('/Chats/ContextAppActions', data, onSuccess, (error) => {
        if (onError)
            onError('Failed to create context hint');
    });
}
function updateContextAppAction(id, data, onSuccess = null, onError = null) {
    adminPut('/Chats/ContextAppActions/' + id, { id: id, ...data }, onSuccess, (error) => {
        if (onError)
            onError('Failed to update context hint');
    });
}
function deleteContextAppAction(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Chats/ContextAppActions/' + id)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting context app action:', error);
        if (onError)
            onError('Failed to delete context hint');
    });
}
function sendChatMessage(customerId, message, onSuccess = null, onError = null) {
    adminPost('/Chats/ChatRequests?customerId=' + customerId, {
        ...message,
        customerId: customerId
    }, onSuccess, (error) => {
        if (onError)
            onError(error || 'Failed to send message');
    });
}
function getChatMessages(filters, onSuccess = null) {
    const params = new URLSearchParams({
        customerId: filters.customerId || '',
        fromDateTime: filters.fromDateTime,
        toDateTime: filters.toDateTime,
    });
    adminGet('/Customers/Chats/Messages?' + params.toString(), onSuccess);
}
export { getPreLoadInstructions, createPreLoadInstruction, updatePreLoadInstruction, deletePreLoadInstruction, getContextAppActions, createContextAppAction, updateContextAppAction, deleteContextAppAction, sendChatMessage, getChatMessages, };
